/* Current Nostalgia - v1.37 (Nov 3 2026): cart add-ons (snippets/cn-cart-addons.liquid) and the
   "Swap for the set" line (snippets/cn-cart-set.liquid).
   - Add: POST /cart/add.js with one unit of the variant.
   - Swap: one POST /cart/update.js that sets the single's line to 0 and the set's variant to 1.
   Then the cart refreshes the way the theme already does: the header bag count from the returned
   section, and a cartUpdate publish, which makes the drawer (cart-drawer-items) and the cart page
   (cart-items) re-render themselves and the free-shipping bar repaint (assets/cn-ux.js). The cart page
   footer (totals) is not re-rendered by the theme on cartUpdate, so it is fetched here.
   Nothing is added without a tap. */
(function () {
  if (window.cnAddonsReady) return;
  window.cnAddonsReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(path, payload) {
    payload.sections = 'cart-icon-bubble';
    payload.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  function paintBubble(data) {
    var html = data && data.sections && data.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (src) bubble.innerHTML = src.innerHTML;
  }

  function refreshCartPageFooter() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer || !footer.dataset.id) return Promise.resolve();
    return fetch(root + 'cart?sections=' + encodeURIComponent(footer.dataset.id), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var html = d[footer.dataset.id];
        if (!html) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
        var dest = footer.querySelector('.js-contents');
        if (src && dest) dest.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function afterChange(data) {
    paintBubble(data);
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cn-addons' });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:updated'));
    refreshCartPageFooter();
  }

  function showError(btn, msg) {
    var box = btn.closest('[data-cn-addons]');
    var el = box && box.querySelector('[data-cn-addons-error]');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  function busy(btn, on, label) {
    if (on) {
      btn.dataset.cnLabel = btn.textContent.trim();
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = label;
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn.dataset.cnLabel) btn.textContent = btn.dataset.cnLabel;
    }
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-cn-addon]');
    var swap = e.target.closest('[data-cn-swap-variant]');
    if (!add && !swap) return;
    e.preventDefault();
    var btn = add || swap;
    if (btn.disabled) return;

    if (add) {
      busy(btn, true, 'Adding…');
      post('cart/add.js', { items: [{ id: Number(btn.dataset.cnAddon), quantity: 1 }] })
        .then(afterChange)
        .catch(function () {
          busy(btn, false);
          btn.disabled = true;
          btn.textContent = 'Sold out';
          showError(btn, 'That piece just sold out.');
        });
      return;
    }

    busy(btn, true, 'Swapping…');
    var updates = {};
    updates[btn.dataset.cnSwapLine] = 0;
    updates[btn.dataset.cnSwapVariant] = 1;
    post('cart/update.js', { updates: updates })
      .then(afterChange)
      .catch(function () {
        busy(btn, false);
        btn.disabled = true;
        btn.textContent = 'Set sold out';
      });
  });
})();
